<template>
  <div>
    <section class="content">
      <ul v-if="detail != ''">
        <li>
          <label>行业：</label>
          <p>{{ detail.trade_name }}</p>
        </li>
        <li>
          <label>岗位名称：</label>
          <p>{{ detail.name }}</p>
        </li>
        <li>
          <label>性别要求：</label>
          <p v-show="detail.gender == 1">男</p>
          <p v-show="detail.gender == 2">女</p>
          <p v-show="detail.gender == 3">不限</p>
        </li>
        <li>
          <label>上班时间：</label>
          <p>{{ detail.work_time }}</p>
        </li>
        <li>
          <label>发新时间：</label>
          <p>{{ detail.pay_time }}</p>
        </li>
        <li>
          <label>预支：</label>
          <p>{{ detail.advance }}</p>
        </li>
        <li>
          <label>硬性年龄要求：</label>
          <p>{{ detail.age }}</p>
        </li>
        <li>
          <label>硬性学历要求：</label>
          <p>{{ detail.education }}</p>
        </li>
        <li>
          <label>硬性征信要求：</label>
          <p>{{ detail.credit_investigation }}</p>
        </li>
        <li>
          <label>是否培训：</label>
          <p v-show="detail.is_train == 1">是</p>
          <p v-show="detail.is_train == 2">否</p>
        </li>
        <li v-show="detail.is_train == 1">
          <label>培训期薪资：</label>
          <p>{{ detail.train_salary }}</p>
        </li>
        <li>
          <label>岗位描述：</label>
          <p>{{ detail.describe }}</p>
        </li>
        <li>
          <label>岗位要求：</label>
          <p>{{ detail.requirement }}</p>
        </li>
        <li>
          <label>创建时间：</label>
          <p>{{ detail.create_time }}</p>
        </li>
        <li>
          <label>修改时间：</label>
          <p>{{ detail.update_time }}</p>
        </li>
        <li>
          <label>创建人：</label>
          <p>{{ detail.user_name }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: ""
    };
  },
  props: {
    detailsStr: {}
  },
  watch: {
    detailsStr() {
      this.detail = this.detailsStr;
    }
  },
  mounted() {
    if (this.detailsStr != undefined) {
      this.detail = this.detailsStr;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  > ul {
    padding: 30px 4%;
    li {
      margin-bottom: 10px;
      min-width: 32%;
      margin-right: 1%;
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
}
</style>
